import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
    1: { // Exercise num
        unit: 'Unit 6',
        id: 'WB4-V2-U6-P43-E1',
        audio: 'img/FriendsPlus/Page43/Audio/audio-e1-p43.mp3',
        video: '',
        component: DesignUnderLine,
        totalInput: 4,
        exerciseKey: 'img/FriendsPlus/Page43/E1/Key/answerKey.png',
        titleImage: '',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page43/E1/1.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/tieude-e1-p43.mp3 ' },
                { url: 'img/FriendsPlus/Page43/E1/3.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page43/E1/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page43/E1/5.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/6.jpg', input: 1, },
                { url: 'img/FriendsPlus/Page43/E1/7.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/8.jpg', input: 1, isCorrect: true },
                { url: 'img/FriendsPlus/Page43/E1/9.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page43/E1/10.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page43/E1/11.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/12.jpg', input: 2, isCorrect: true },
                { url: 'img/FriendsPlus/Page43/E1/13.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/14.jpg', input: 2, },
                { url: 'img/FriendsPlus/Page43/E1/15.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page43/E1/16.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page43/E1/17.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/18.jpg', input: 3, isCorrect: true },
                { url: 'img/FriendsPlus/Page43/E1/19.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/20.jpg', input: 3, },
                { url: 'img/FriendsPlus/Page43/E1/21.jpg' },
            ],
            [
                // Column8
                { url: 'img/FriendsPlus/Page43/E1/22.jpg' },
            ],
            [
                // Column9
                { url: 'img/FriendsPlus/Page43/E1/23.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/24.jpg', input: 4, isCorrect: true },
                { url: 'img/FriendsPlus/Page43/E1/25.jpg' },
                { url: 'img/FriendsPlus/Page43/E1/26.jpg', input: 4, },
                { url: 'img/FriendsPlus/Page43/E1/27.jpg' },
            ],
            [
                // Column10
                { url: 'img/FriendsPlus/Page43/E1/28.jpg' },
            ],


        ]
    },

    2: { // Exercise num
        unit: 'Unit 6',
        id: 'WB4-V2-U6-P43-E2',
        audio: '',
        video: '',
        exerciseKey: 'img/FriendsPlus/Page43/E2/Key/answerKey.png',
        component: D1,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page43/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page43/E2/2.jpg' },
                { url: 'img/FriendsPlus/Page43/E2/3.jpg', input: true, answer: "sn" },
                { url: 'img/FriendsPlus/Page43/E2/4.jpg' },
                { url: 'img/FriendsPlus/Page43/E2/5.jpg', input: true, answer: "st" },
                { url: 'img/FriendsPlus/Page43/E2/6.jpg' },
                { url: 'img/FriendsPlus/Page43/E2/7.jpg', input: true, answer: "sk" },
                { url: 'img/FriendsPlus/Page43/E2/8.jpg' },
            ],


        ],
    },
    3: { // Exercise num
        unit: 'Unit 6',
        id: 'WB4-V2-U6-P43-E3',
        audio: '',
        video: '',
        exerciseKey: 'img/FriendsPlus/Page43/E3/Key/answerKey.png',
        component: D1,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page43/E3/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page43/E3/2.jpg' },
                { url: 'img/FriendsPlus/Page43/E3/3.jpg', input: true, answer: "snow" },
                { url: 'img/FriendsPlus/Page43/E3/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page43/E3/5.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page43/E3/6.jpg' },
                { url: 'img/FriendsPlus/Page43/E3/7.jpg', input: true, answer: "smile" },
                { url: 'img/FriendsPlus/Page43/E3/8.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page43/E3/9.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page43/E3/10.jpg' },
                { url: 'img/FriendsPlus/Page43/E3/11.jpg', input: true, answer: "stars" },
                { url: 'img/FriendsPlus/Page43/E3/12.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page43/E3/13.jpg' },
            ],
            [
                // Column8
                { url: 'img/FriendsPlus/Page43/E3/14.jpg' },
                { url: 'img/FriendsPlus/Page43/E3/15.jpg', input: true, answer: "sky" },
                { url: 'img/FriendsPlus/Page43/E3/16.jpg' },
            ],
            [
                // Column9
                { url: 'img/FriendsPlus/Page43/E3/17.jpg' },
            ],



        ],
    },

}

export default json;